<template>
  <div :class="$style.errorMessage">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 167 88" :class="$style.emptyIcon" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="none" fill-rule="evenodd"><path d="M160 1a7 7 0 010 14h-40a7 7 0 010 14h22a7 7 0 010 14h-10.174c-4.874 0-8.826 3.134-8.826 7 0 2.577 2 4.91 6 7a7 7 0 010 14H46a7 7 0 010-14H7a7 7 0 010-14h40a7 7 0 000-14H22a7 7 0 010-14h40a7 7 0 010-14h98zm0 28a7 7 0 110 14 7 7 0 010-14z" fill="#F1F3F4" opacity=".531"/><g transform="translate(52 2)" stroke-width="2.5"><circle stroke="#93999F" fill-opacity=".835" fill="#FFF" cx="33.5" cy="33.5" r="33.5"/><path d="M28.132 59.494c1.759.325 3.548.493 5.368.506C48.136 60 60 48.136 60 33.5S48.136 7 33.5 7c-3.76 0-7.336.783-10.576 2.195A26.604 26.604 0 009.896 21.442 26.388 26.388 0 007 33.5a26.402 26.402 0 006.684 17.596" stroke="#93999F" fill="#FFF" stroke-linecap="round"/><path d="M16.797 54.075a26.473 26.473 0 007.204 4.172" stroke="#90999D" stroke-linecap="round"/><path d="M34 15c-1.723 0-3.392.23-4.979.659C20.943 17.847 15 25.229 15 34" stroke="#E2E8E8" stroke-linecap="round"/><path stroke="#92999F" d="M61 60l6 6"/><path d="M66.03 65.03a4.847 4.847 0 000 6.854L77.116 82.97a4.847 4.847 0 106.854-6.854L72.884 65.03a4.847 4.847 0 00-6.854 0z" stroke="#92999F" fill-opacity=".835" fill="#FFF"/><path stroke="#FFF" stroke-linecap="round" d="M71 67l11 11"/></g></g></svg>
    <p>
      <strong>No results found.</strong>
    </p>
    <slot
      name="emptyMessage"
    />
  </div>
</template>

<script>
export default {
  name: 'NoRecordsFound',
};
</script>

<style module>
.errorMessage {
  margin: auto;
  padding: 50px 50px 20px;
  text-align: center;
  width: 305px;
}

.emptyIcon {
  margin-bottom: 15px;
  width: 120px;
}
</style>
